import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#F7F8F8',
    color100: '#EFF0F0',
    color200: '#E0E1E1',
    color300: '#D0D2D1',
    color400: '#C1C3C2',
    color500: '#B1B4B3',
    color600: '#8E908F',
    color700: '#6A6C6B',
    color800: '#474848',
    color900: '#232424'
  },
  default: {
    color50: '#D8ECF3',
    color100: '#B1D9E7',
    color200: '#8AC6DC',
    color300: '#63B3D0',
    color400: '#3CA0C4',
    color500: '#158DB8',
    color600: '#117193',
    color700: '#0D556E',
    color800: '#08384A',
    color900: '#041C25'
  },
  accent: {
    color50: '#E4E6E7',
    color100: '#C8CCCF',
    color200: '#ADB3B8',
    color300: '#929AA0',
    color400: '#768088',
    color500: '#5b6770',
    color600: '#49525A',
    color700: '#373E43',
    color800: '#24292D',
    color900: '#121516'
  },
  positive: {
    color50: '#F9DBD9',
    color100: '#F3B8B3',
    color200: '#ED948E',
    color300: '#E67068',
    color400: '#E04D42',
    color500: '#da291c',
    color600: '#da291c',
    color700: '#831911',
    color800: '#57100B',
    color900: '#2C0806'
  },
  negative: {
    color50: '#F9DBD9',
    color100: '#F3B8B3',
    color200: '#ED948E',
    color300: '#E67068',
    color400: '#E04D42',
    color500: '#DA291C',
    color600: '#AE2116',
    color700: '#871711',
    color800: '#5A0F0B',
    color900: '#2D0806'
  },
  special: {
    color50: '#D5D5D5',
    color100: '#AAAAAA',
    color200: '#808080',
    color300: '#555555',
    color400: '#2B2B2B',
    color500: '#000000',
    color600: '#000000',
    color700: '#000000',
    color800: '#000000',
    color900: '#000000'
  }
};

const statusBarBackgroundColor = colors.positive.color500;

const variant: ACPVariant = {
  id: 'www.hebdebit.com',
  productTitle: 'H-E-B Debit Account',
  productType: 'consumer_dda',
  accessDomain: {
    subdomain: 'www',
    domain: 'hebdebit',
    topLevelDomain: 'com'
  },
  colors,
  themeConfiguration: {
    acpActivationAppBar: {
      defaultBackgroundColor: colors.positive.color500
    },
    acpRisingTideLayout: {
      appBarDefaultBackgroundColor: colors.positive.color500
    },
    acpDashboard: {
      cashbackAmountBackgroundColor: colors.positive.color500
    },
    acpSpendingAccount: {
      cashbackTextBackgroundColor: colors.positive.color500
    },
    illustration: {
      default: { ...colors.special },
      special: { ...colors.positive }
    },
    newpassword: {
      neutral: colors.neutral.color200,
      negative: colors.negative.color500,
      positive: colors.special.color500,
      labelColor: colors.neutral.color700
    },

    tileIcon: {
      positive: {
        color50: '#ffffff',
        color100: '#ffffff',
        color200: '#ffffff',
        color300: '#ffffff',
        color500: colors.special.color500
      }
    },
    featureIcon: {
      positive: colors.special.color500
    }
  },
  legacyAcpTheme: 'heb-debit',
  legacyAcpBrandName: 'heb-debit',
  legacyLegosTheme: 'heb-debit',
  status_bar_background_color: statusBarBackgroundColor,
  status_bar_foreground_color: 'light',
  contactInfo: {
    name: 'H-E-B Debit',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@hebdebit.com',
    fax_formatted: '(855)-306-9960',
    phone_formatted: '(800)-268-4739',
    phone: '8002684739',
    phone_international: '737-220-8956',
    balance_check_phone: '8663877363',
    balance_check_phone_formatted: '1-866-387-7363',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '',
      appsFlyerBannerKey: '0f152d74-f629-4420-b245-d5b39f77ac77',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: true,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: false,
      showScanCardRegistration: false,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: false
    },
    misc: {
      distributor: 'HEB',
      layoutComponentOverride: false,
      loader: 'generic',
      inAppBrowserAcquisitionToolbarBackgroundColor: statusBarBackgroundColor,
      inAppBrowserAcquisitionDisableToolbarText: true,
      inAppBrowserAcquisitionDisableToolbarTranslucent: true,
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#414142',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#84bd00',
      marketingSiteUrl: 'https://www.hebdebit.com',
      marketingSiteLinkText: 'HEBDebit.com',
      locationSearchMax: '25',
      atmFinderLinkText: 'Find an ATM',
      addMoneyLinkText: 'Add cash in person',
      iOSAppId: '1514744431'
    },
    content: {
      signUpContent: "Don't have an account? Sign up today.<sup>1</sup>",
      sendReceiveMoneyText: 'Send between friends',
      sendReceiveMoneyIcon: 'shareFriends',
      accountTypeText: 'Spending Account',
      fundAccountText: 'Ways to add money',
      benefitsCenterTitle: 'H-E-B account benefits',
      copyrightStatement: 'Netspend Corporation'
    },
    disclaimers: {
      optionalSavingsDisclaimer: `The Optional Savings Account linked to your H-E-B&reg; Debit Account is made available to Accountholders through Pathward, National Association, Member FDIC. To open a Savings Account, consent to receive communications from us in electronic form is required. Interest is calculated on the Average Daily Balance(s) of the Savings Account and is paid quarterly. <br/><br/> &#8226; If the Average Daily Balance is $2,000.00 or less, the interest rate paid on the entire balance will be 5.87% with an annual percentage yield (APY) of 6.00%. <br/><br/> &#8226; If the Average Daily Balance is more than $2,000.00, the interest rate paid on the portion of the Average Daily Balance which exceeds $2,000.00 will be .49% with an APY of .50%, and the interest paid on the portion of the Average Daily Balance which is $2,000.00 or less will be 5.87%. The APY for this tier will range from 6.00% to .60%, depending on the balance in the account.<br/><br/> The interest rates and APYs of each tier may change. The APYs were accurate as of {currentMonthyear}. No minimum balance to open Savings Account or obtain the yield(s). Savings Account funds are withdrawn through the H-E-B Debit Account (maximum 6 such transfers per calendar month) and transaction fees could reduce the interest earned on the Savings Account.`,

      rideShareDisclaimer: `Mastercard, Pathward<sup>&reg;</sup>, National Association, and Netspend Corporation are neither licensed insurers nor licensed insurance intermediaries,
      and do not sell, solicit, nor provide advice on insurance products. The insurance benefits are provided under a group policy issued by New Hampshire Insurance Company,
      an AIG company. Benefits are provided to you, the H-E-B&reg; Debit Account cardholder, at no additional charge; provided, however,
      you are required to pay your monthly cell phone bill on an eligible cellular phone with your H-E-B&reg; Debit Account card to be eligible for coverage.
      Non-insurance services may have associated costs, which will be your responsibility. Any insurance claim filed pursuant to your Mastercard sponsored insurance program by calling
      <a href="tel:1-844-878-1906" style="text-decoration: none;color: unset;"> 1-844-878-1906 </a> will be evaluated by AIG, or their authorized local representative, and, if accepted,
      will be paid by AIG. Coverage is determined by the terms, conditions and exclusions of the policies applicable to your H-E-B&reg; Debit Account card, as specified by the underwriter,
      and is subject to change with notice. This site does not supplement or replace the policy or Program Terms. Submission of a claim does not guarantee coverage or coverage availability.`,

      cellPhoneProtectionDisclaimer: `Mastercard, Pathward<sup>&reg;</sup>, National Association, and Netspend Corporation are neither licensed insurers nor licensed insurance intermediaries,
      and do not sell, solicit, nor provide advice on insurance products. The insurance benefits are provided under a group policy issued by New Hampshire Insurance Company,
      an AIG company. Benefits are provided to you, the H-E-B&reg; Debit Account cardholder, at no additional charge; provided, however,
      you are required to pay your monthly cell phone bill on an eligible cellular phone with your H-E-B&reg; Debit Account card to be eligible for coverage.
      Non-insurance services may have associated costs, which will be your responsibility. Any insurance claim filed pursuant to your Mastercard sponsored insurance program by calling
      <a href="tel:1-844-878-1906" style="text-decoration: none;color: unset;"> 1-844-878-1906 </a> will be evaluated by AIG, or their authorized local representative, and, if accepted,
      will be paid by AIG. Coverage is determined by the terms, conditions and exclusions of the policies applicable to your H-E-B&reg; Debit Account card, as specified by the underwriter,
      and is subject to change with notice. This site does not supplement or replace the policy or Program Terms. Submission of a claim does not guarantee coverage or coverage availability.`,

      idProtectionDisclaimer: `Call <a href="tel:866-470-5491" style="text-decoration: none;color: unset;">
      866-470-5491 </a> or visit <a href="https://benefitscenter.idprotectiononline.com" target="_blank"
      style="text-decoration: none;color: unset;" rel="noopener"> https://benefitscenter.idprotectiononline.com </a> to activate the ID Theft Protection Services. The services are provided to you, the H-E-B&reg; Debit Account cardholder, at no additional cost, but you must activate. Service provided by Generali Global Assistance, through an agreement with Mastercard&reg; and Pathward<sup>&reg;</sup>, National Association. See your Guide to Benefits for terms and conditions and your Online Account Center for more details.`,

      atmDisclaimer: `Free ATM withdrawals at H-E-B branded ATMs (“in-network ATMs”) in the US. Visit your Online Account Center for a list of in-network ATMs. Transactions at all non-H-E-B branded ATMs are $2.95, operator may assess additional charges.`,

      directDepositDisclaimer: `Faster funding claim is based on a comparison of the Pathward<sup>&reg;</sup>, National Association, policy of making funds available upon receipt of payment instruction versus the typical banking practice of posting funds at settlement. Fraud prevention restrictions may delay availability of funds with or without notice. Early availability of funds requires payor's support of direct deposit and is subject to the timing of payor’s payment instruction.`,

      participationFeeDisclaimer: `There is no fee to add funds at participating H-E-B locations for the H-E-B Debit Account. See the Deposit Agreement for details and additional fees`,

      fivePercentDisclaimer: `5% cash back applies only to H-E-B brand products purchased at a store register at H-E-B owned stores,
      or on <a href="https://heb.com" target="_blank" style="color: ${colors.default.color500};" rel="noopener">heb.com</a> using your
      H-E-B Debit Card issued by Pathward<sup>&reg;</sup>, National Association, excluding “digital wallet” transactions.
      5% cash back is limited to the amount of the purchase paid for using your H-E-B Debit Card and account number.
      Not valid for online purchases at Central Market&reg;, Mi Tienda&reg;, Joe V's Smart Shop&reg;, or through Favor&reg;.
      No cash back for pharmacy prescriptions, gift cards, restaurants, fuel, car washes,
      purchases made using digital wallet software rather than presentation of your Debit Card account number,
      purchases made on the H-E-B Go app or at H-E-B Go kiosks, or purchases at mobile point-of-sale systems deployed in store.
      Cash back will be credited to your available balance within 7 business days after applicable purchase. Cash back offer by H-E-B.
      Pathward, N.A., Mastercard, and Netspend Corporation do not sponsor, and are not affiliated with the offer.`,

      importantPatriotActDisclosure: `1 <strong>IMPORTANT INFORMATION FOR OPENING A NEW DEPOSIT ACCOUNT:</strong> To help the federal government fight the
      funding of terrorism and money laundering activities, the USA PATRIOT Act requires us to obtain, verify, and record
      information that identifies each person who opens an Account. <strong>WHAT THIS MEANS FOR YOU:</strong> When you
      open an Account, we will ask for your <strong>name, address, date of birth, and your government ID number</strong>.
      We may also ask to see a copy of your driver's license or other documents at any time. All Accounts are opened
      subject to our ability to verify your identity by requiring acceptable types of identification. We may validate the
      information you provide us to ensure we have a reasonable belief of your identity. If we are not able to verify your
      identity to our satisfaction, we will not open your Account or we may close the Account if it was previously funded.
      Your Account is subject to fraud prevention restrictions at any time, with or without notice.`
    },
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'dda-activation',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
